/* Mythic Transfers Fresh Theme */
class MythicCart {
  static async add(variantId, quantity = 1) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity })
    });
    return response.json();
  }

  static async updateCount() {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = cart.item_count;
    });
    return cart;
  }
}
window.MythicCart = MythicCart;
console.log('🦄 Mythic Fresh Theme loaded!');
